import type { MatchStaff } from '../types/match'

export function getStaffFullName(staff: MatchStaff) {
  return staff.person?.cardNameF || `${staff.person?.firstName} ${staff.person?.lastName}`
}
